import {
  NonTeamTierConfigType,
  TierConfigItem,
  TeamTierConfigType,
  UserTier,
  NinjaSubscriptionPlan,
} from 'src/types';
import { LabelFree } from 'src/components/LabelFree';
import LabelStandard from 'src/components/LabelStandard/LabelStandard';
import { LabelPro } from 'src/components/LabelPro';
import { LabelUltra } from 'src/components/LabelUltra';
import { LabelEnterpriseTrial } from 'src/components/LabelEnterpriseTrial';
import { LabelEnterprise } from 'src/components/LabelEnterprise';
import { LabelBusiness } from 'src/components/LabelBusiness';
import type { ReactElement } from 'react';
import { LabelUltraTrial } from 'src/components/LabelUltraTrial';
import { LabelStandardTrial } from 'src/components/LabelStandardTrial';
import { LabelSuperNinjaUltra } from 'src/components/LabelSuperNinjaUltra';
import { LabelBusinessMax } from 'src/components/LabelBusinessMax';
import { LabelGuest } from 'src/components/LabelGuest';
import { SUPER_PROJECT_NAME } from 'src/constants/global';
import styles from './constStyles.module.scss';

const getMoreText = `Get more with Ninja & ${SUPER_PROJECT_NAME}`;

export const openTierConfig: TierConfigItem = {
  labelShort: <LabelGuest />,
  labelLong: <LabelGuest />,
  upsellFooterTitle: 'Log in or sign up for free',
  upsellFooterDescription: (
    <div className={styles.openTierDescription}>
      <span>Save chats to history and access to</span>
      <ul>
        <li>40+ AI models</li>
        <li>Free {SUPER_PROJECT_NAME} monthly tasks to start</li>
        <li>Complete project delivery</li>
      </ul>
    </div>
  ),
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const freeTierConfig: TierConfigItem = {
  labelShort: <LabelFree />,
  labelLong: <LabelFree />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: `Unlock 40+ premium AI models with unlimited Ninja tasks & unlimited ${SUPER_PROJECT_NAME} tasks.`,
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: 'Upgrade',
};

export const standardTierConfig: TierConfigItem = {
  labelShort: <LabelStandard />,
  labelLong: <LabelStandard />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Flexible plans for personal and business success',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const standardTrialTierConfig: TierConfigItem = {
  labelShort: <LabelStandardTrial />,
  labelLong: <LabelStandardTrial />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Flexible plans for personal and business success',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: 'Upgrade',
};

export const standardTeamOwnerTierConfig: TierConfigItem = {
  labelShort: <LabelBusiness />,
  labelLong: <LabelBusiness />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Expand your team & unlock advanced features',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const standardTeamAdminTierConfig: TierConfigItem = {
  labelShort: <LabelBusiness />,
  labelLong: <LabelBusiness />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Expand your team & unlock advanced features',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const standardTeamMemberTierConfig: TierConfigItem = {
  labelShort: <LabelBusiness />,
  labelLong: <LabelBusiness />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Ask your workspace owner to unlock more features.',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const proTierConfig: TierConfigItem = {
  labelShort: <LabelPro />,
  labelLong: <LabelPro />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Flexible plans for personal and business success',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: 'Upgrade',
};

export const proTeamOwnerTierConfig: TierConfigItem = {
  labelShort: <LabelBusiness />,
  labelLong: <LabelBusiness />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Expand your team & unlock advanced features',
  upsellFooterSecondaryButtonTitle: 'Upgrade',
  upsellFooterPrimaryButtonTitle: null,
};

export const proTeamAdminTierConfig: TierConfigItem = {
  labelShort: <LabelBusiness />,
  labelLong: <LabelBusiness />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Expand your team & unlock advanced features',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const proTeamMemberTierConfig: TierConfigItem = {
  labelShort: <LabelBusiness />,
  labelLong: <LabelBusiness />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Ask your workspace owner to unlock more features.',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const ultraTierConfig: TierConfigItem = {
  labelShort: <LabelUltra />,
  labelLong: <LabelUltra />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Flexible plans for personal and business success',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: 'Upgrade',
};

export const ultraTrialTierConfig: TierConfigItem = {
  labelShort: <LabelUltraTrial />,
  labelLong: <LabelUltraTrial />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Flexible plans for personal and business success',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: 'Upgrade',
};

export const ultraTeamOwnerTierConfig: TierConfigItem = {
  labelShort: <LabelBusiness />,
  labelLong: <LabelBusiness />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Need more capabilities for your business?',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: 'Upgrade',
};

export const ultraTeamAdminTierConfig: TierConfigItem = {
  labelShort: <LabelBusiness />,
  labelLong: <LabelBusiness />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Invite coworkers to join your team.',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const ultraTeamMemberTierConfig: TierConfigItem = {
  labelShort: <LabelBusiness />,
  labelLong: <LabelBusiness />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaProTeamOwnerTierConfig: TierConfigItem = {
  labelShort: <LabelBusinessMax label="Pro" />,
  labelLong: <LabelBusinessMax label="Pro" />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaUltraTeamOwnerTierConfig: TierConfigItem = {
  labelShort: <LabelBusinessMax label="Ultra" />,
  labelLong: <LabelBusinessMax label="Ultra" />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaMaxTeamOwnerTierConfig: TierConfigItem = {
  labelShort: <LabelBusinessMax label="Max" />,
  labelLong: <LabelBusinessMax label="Max" />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaProTeamAdminTierConfig: TierConfigItem = {
  labelShort: <LabelBusinessMax label="Pro" />,
  labelLong: <LabelBusinessMax label="Pro" />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaUltraTeamAdminTierConfig: TierConfigItem = {
  labelShort: <LabelBusinessMax label="Ultra" />,
  labelLong: <LabelBusinessMax label="Ultra" />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaMaxTeamAdminTierConfig: TierConfigItem = {
  labelShort: <LabelBusinessMax label="Max" />,
  labelLong: <LabelBusinessMax label="Max" />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaProTeamMemberTierConfig: TierConfigItem = {
  labelShort: <LabelBusinessMax label="Pro" />,
  labelLong: <LabelBusinessMax label="Pro" />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaUltraTeamMemberTierConfig: TierConfigItem = {
  labelShort: <LabelBusinessMax label="Ultra" />,
  labelLong: <LabelBusinessMax label="Ultra" />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaMaxTeamMemberTierConfig: TierConfigItem = {
  labelShort: <LabelBusinessMax label="Max" />,
  labelLong: <LabelBusinessMax label="Max" />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const enterpriseTrialTierConfig: TierConfigItem = {
  labelShort: <LabelEnterpriseTrial />,
  labelLong: <LabelEnterpriseTrial />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const enterpriseTierConfig: TierConfigItem = {
  labelShort: <LabelEnterprise />,
  labelLong: <LabelEnterprise />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaProTierConfig: TierConfigItem = {
  labelShort: <LabelSuperNinjaUltra label="Pro" />,
  labelLong: <LabelSuperNinjaUltra label="Pro" />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaStandardTierConfig: TierConfigItem = {
  labelShort: <LabelSuperNinjaUltra label="Standard" />,
  labelLong: <LabelSuperNinjaUltra label="Standard" />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaUltraTierConfig: TierConfigItem = {
  labelShort: <LabelSuperNinjaUltra label="Ultra" />,
  labelLong: <LabelSuperNinjaUltra label="Ultra" />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaMaxTierConfig: TierConfigItem = {
  labelShort: <LabelSuperNinjaUltra label="Max" />,
  labelLong: <LabelSuperNinjaUltra label="Max" />,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const superNinjaUltraTrialTierConfig: TierConfigItem = {
  labelShort: <LabelSuperNinjaUltra isTrial />,
  labelLong: <LabelSuperNinjaUltra isTrial />,
  upsellFooterTitle: getMoreText,
  upsellFooterDescription: 'Flexible plans for personal and business success',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: 'Upgrade',
};

export const defaultTierConfig: TierConfigItem = {
  labelShort: null,
  labelLong: null,
  upsellFooterTitle: '',
  upsellFooterDescription: '',
  upsellFooterSecondaryButtonTitle: null,
  upsellFooterPrimaryButtonTitle: null,
};

export const nonTeamTierConfig: NonTeamTierConfigType = {
  [UserTier.OPEN]: openTierConfig,
  [UserTier.FREE]: freeTierConfig,
  [UserTier.STANDARD]: standardTierConfig,
  [UserTier.PRO]: proTierConfig,
  [UserTier.PRO_TRIAL]: defaultTierConfig,
  [UserTier.ULTRA]: ultraTierConfig,
  [UserTier.SUPERNINJA_STANDARD]: superNinjaStandardTierConfig,
  [UserTier.ENTERPRISE_TRIAL]: enterpriseTrialTierConfig,
  [UserTier.ENTERPRISE]: enterpriseTierConfig,
  [UserTier.TESTING]: defaultTierConfig,
  [UserTier.PAID]: defaultTierConfig,
  [UserTier.TEAM]: defaultTierConfig,
  [UserTier.API_TIER_1]: defaultTierConfig, // TODO: need to check if this is correct
  [UserTier.ULTRA_TRIAL]: ultraTrialTierConfig,
  [UserTier.STANDARD_TRIAL]: standardTrialTierConfig,
  [UserTier.SUPERNINJA_ULTRA_TRIAL]: superNinjaUltraTrialTierConfig,
  [UserTier.SUPERNINJA_PRO]: superNinjaProTierConfig,
  [UserTier.SUPERNINJA_ULTRA]: superNinjaUltraTierConfig,
  [UserTier.SUPERNINJA_MAX]: superNinjaMaxTierConfig,
  [UserTier.INTERNAL_UNLIMITED]: defaultTierConfig,
};

export const teamOwnerTierConfig: TeamTierConfigType = {
  [UserTier.TEAMS_STANDARD]: standardTeamOwnerTierConfig,
  [UserTier.TEAMS_PRO]: proTeamOwnerTierConfig,
  [UserTier.TEAMS_ULTRA]: ultraTeamOwnerTierConfig,
  [UserTier.TEAMS_SUPERNINJA_ULTRA]: superNinjaUltraTeamOwnerTierConfig,
  [UserTier.BUSINESS_SUPERNINJA_PRO]: superNinjaProTeamOwnerTierConfig,
  [UserTier.BUSINESS_SUPERNINJA_ULTRA]: superNinjaUltraTeamOwnerTierConfig,
  [UserTier.BUSINESS_SUPERNINJA_MAX]: superNinjaMaxTeamOwnerTierConfig,
  [UserTier.CREDIT_PRO]: superNinjaMaxTeamOwnerTierConfig,
  [UserTier.CREDIT_BUSINESS_PRO]: superNinjaMaxTeamOwnerTierConfig,
};

export const teamAdminTierConfig: TeamTierConfigType = {
  [UserTier.TEAMS_STANDARD]: standardTeamAdminTierConfig,
  [UserTier.TEAMS_PRO]: proTeamAdminTierConfig,
  [UserTier.TEAMS_ULTRA]: ultraTeamAdminTierConfig,
  [UserTier.TEAMS_SUPERNINJA_ULTRA]: superNinjaUltraTeamAdminTierConfig,
  [UserTier.BUSINESS_SUPERNINJA_PRO]: superNinjaProTeamAdminTierConfig,
  [UserTier.BUSINESS_SUPERNINJA_ULTRA]: superNinjaUltraTeamAdminTierConfig,
  [UserTier.BUSINESS_SUPERNINJA_MAX]: superNinjaMaxTeamAdminTierConfig,
  [UserTier.CREDIT_PRO]: superNinjaMaxTeamAdminTierConfig,
  [UserTier.CREDIT_BUSINESS_PRO]: superNinjaMaxTeamAdminTierConfig,
};

export const teamMemberTierConfig: TeamTierConfigType = {
  [UserTier.TEAMS_STANDARD]: standardTeamMemberTierConfig,
  [UserTier.TEAMS_PRO]: proTeamMemberTierConfig,
  [UserTier.TEAMS_ULTRA]: ultraTeamMemberTierConfig,
  [UserTier.TEAMS_SUPERNINJA_ULTRA]: superNinjaUltraTeamMemberTierConfig,
  [UserTier.BUSINESS_SUPERNINJA_PRO]: superNinjaProTeamMemberTierConfig,
  [UserTier.BUSINESS_SUPERNINJA_ULTRA]: superNinjaUltraTeamMemberTierConfig,
  [UserTier.BUSINESS_SUPERNINJA_MAX]: superNinjaMaxTeamMemberTierConfig,
  [UserTier.CREDIT_PRO]: superNinjaMaxTeamMemberTierConfig,
  [UserTier.CREDIT_BUSINESS_PRO]: superNinjaMaxTeamMemberTierConfig,
};

/**
 * @deprecated
 */
export const availableInLabel: Partial<Record<UserTier, ReactElement>> = {
  [UserTier.STANDARD]: <LabelStandard />,
  [UserTier.PRO]: <LabelPro />,
  [UserTier.ULTRA]: <LabelUltra />,
  [UserTier.TEAMS_STANDARD]: <LabelStandard />,
  [UserTier.TEAMS_PRO]: <LabelPro />,
  [UserTier.TEAMS_ULTRA]: <LabelUltra />,
  [UserTier.TEAMS_SUPERNINJA_ULTRA]: <LabelBusinessMax label="Ultra" />,
  [UserTier.SUPERNINJA_ULTRA]: <LabelSuperNinjaUltra />,
};

export const tierLevels: string[] = [
  NinjaSubscriptionPlan.STANDARD.toString(),
  NinjaSubscriptionPlan.PRO.toString(),
  NinjaSubscriptionPlan.ULTRA.toString(),
  NinjaSubscriptionPlan.SUPERNINJA_PRO.toString(),
  NinjaSubscriptionPlan.SUPERNINJA_ULTRA.toString(),
  NinjaSubscriptionPlan.SUPERNINJA_MAX.toString(),
  NinjaSubscriptionPlan.TEAMS_STANDARD.toString(),
  NinjaSubscriptionPlan.TEAMS_PRO.toString(),
  NinjaSubscriptionPlan.TEAMS_ULTRA.toString(),
  NinjaSubscriptionPlan.BUSINESS_SUPERNINJA_PRO.toString(),
  NinjaSubscriptionPlan.BUSINESS_SUPERNINJA_ULTRA.toString(),
  NinjaSubscriptionPlan.BUSINESS_SUPERNINJA_MAX.toString(),
  NinjaSubscriptionPlan.TEAMS_SUPERNINJA_ULTRA.toString(),
];
